<template>
  <div></div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ShowResetPasswordSuccess',
  mounted () {
    if (this.successState) {
      this.successToast(this.getSlotText('txtCopySuccessToast', 'Du hast dein Passwort erfolgreich gesetzt'))
      this.resetSuccess()
    }
  },
  computed: {
    ...mapGetters('resetPassword', ['successState'])
  },
  methods: {
    ...mapMutations('resetPassword', ['resetSuccess'])
  }
}
</script>
